<template>
  <div>
    <FormInput label="Chat ID" :value="data.chat_id" hint="@channelusername or @groupusername" @update="data.chat_id=$event"></FormInput>
    <h6>Permissions</h6>
    <CheckBox label="can send messages" :value="data.permissions.can_send_messages" @change="data.permissions.can_send_messages = $event"></CheckBox>
    <CheckBox label="can send media messages" :value="data.permissions.can_send_media_messages" @change="data.permissions.can_send_media_messages = $event"></CheckBox>
    <CheckBox label="can send polls" :value="data.permissions.can_send_polls" @change="data.permissions.can_send_polls = $event"></CheckBox>
    <CheckBox label="can send other messages" :value="data.permissions.can_send_other_messages" @change="data.permissions.can_send_other_messages = $event"></CheckBox>
    <CheckBox label="can add web page previews" :value="data.permissions.can_add_web_page_previews" @change="data.permissions.can_add_web_page_previews = $event"></CheckBox>
    <CheckBox label="can change info" :value="data.permissions.can_change_info" @change="data.permissions.can_change_info = $event"></CheckBox>
    <CheckBox label="can invite users" :value="data.permissions.can_invite_users" @change="data.permissions.can_invite_users = $event"></CheckBox>
    <CheckBox label="can pin messages" :value="data.permissions.can_pin_messages" @change="data.permissions.can_pin_messages = $event"></CheckBox>
  </div>
</template>


<script>
import FormInput from '@/components/tasks/fields/FormInput.vue'
import CheckBox from '@/components/tasks/fields/CheckBox.vue'

export default {
  name: 'SetChatPermissions',
  components:{
    FormInput,
    CheckBox
  },
  props: {
    data: Object,
  },
}
</script>
